import React from 'react'
import FirebaseContext from "../../firebase/context";

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container, Button, Typography, Grid } from '@material-ui/core';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import CompAdminExamenAdd from '../components/CompAdminExamenAdd';
import CompExamenesItem from '../components/CompExamenesItem';
import CompAdminExamenConfg from '../components/CompAdminExamenConfg';

const style = {
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: 650
    },
};

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    table: {
        minWidth: 700,
    },
    tableHead: {
        // backgroundColor: theme.palette.common.primary,
        backgroundColor: "#29588F",
        // color: theme.palette.common.white,
        Color: "#f5f5f5",
    },
}));


const PagAdmExamen = () => {

    const classes = useStyles();


    const { firebase } = React.useContext(FirebaseContext);
    const [showExamenAdd, setShowExamenAdd] = React.useState(false)
    const [examenes, setExamenes] = React.useState([])
    const [examenUpdate, setExamenUpdate] = React.useState(false)
  
 
    //////////////////////////////////////////////////////////////////////////////   
    React.useEffect(() => {
        getExamenes();
    }, [examenUpdate]);

    function getExamenes() {
        firebase.db.collection("colExamenes").get().then(snapshot => {
            const arrayExamenes = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setExamenes(arrayExamenes);
            setExamenUpdate(false)

        });
    }

    return (
        <Container style={style.cardGrid}>

            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell >
                                <Typography style={{ color: '#FFFFFF' }} >EXAMENES</Typography>
                            </TableCell>
                            <TableCell></TableCell>

                            <TableCell align="right">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<LibraryAddIcon />}
                                    onClick={() => setShowExamenAdd(true)}
                                >
                                    AGREGAR
                               </Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {showExamenAdd
                            ? <CompAdminExamenAdd setShowExamenAdd={setShowExamenAdd} />
                            : null
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Container style={style.container}>
            <Grid container spacing={1}>

                <Grid item xs={12} sm={12} style={style.gridTextfield}>
                    <Paper style={style.paperMenu}>
                        {examenes.map((item, index) => (
                            <CompAdminExamenConfg
                                key={index}
                                item={item}
                                index={index + 1}
                                setExamenUpdate={setExamenUpdate}
                            />
                        ))}
                    </Paper>
                </Grid>              

            </Grid>
        </Container>

        </Container>
    )
}

export default PagAdmExamen
